// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"6":"3301fe9f","70":"4edd08d1","857":"67408c33"}[chunkId] + ".js";
};